import React, { useState, useEffect } from 'react';

const BackgroundMedia = ({ type = 'image', src, mobileSrc, alt = '', children }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Use mobile source if available and on mobile device
  const imageSrc = (isMobile && mobileSrc) ? mobileSrc : src;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        margin: 0,
        padding: 0,
        overflow: 'hidden'
      }}
    >
      {type === 'image' ? (
        <img
          src={imageSrc}
          alt={alt}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
            margin: 0,
            padding: 0,
            display: 'block'
          }}
        />
      ) : (
        <video
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
            margin: 0,
            padding: 0,
            display: 'block'
          }}
        >
          <source src={src} type="video/mp4" />
        </video>
      )}

      <div
        style={{
          position: 'relative',
          zIndex: 10,
          width: '100%',
          height: '100%',
          margin: 0,
          padding: 0
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default BackgroundMedia;
